import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47648508"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guesser-page" }
const _hoisted_2 = { class: "page-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "guesser-title" }, "BGG Game Guesser")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "header-daily"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "guesser-subtitle" }, "Guess the game from screenshots — earn clues with every wrong answer, score up to 4 points per game.", -1))
const _hoisted_6 = {
  key: 0,
  class: "unavailable-msg mt-3"
}
const _hoisted_7 = {
  key: 1,
  class: "loading-section"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, "Loading challenge...", -1))
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "screenshot-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "carousel-controls"
}
const _hoisted_13 = { class: "carousel-label" }
const _hoisted_14 = {
  key: 1,
  class: "clues-section"
}
const _hoisted_15 = {
  key: 2,
  class: "score-pips"
}
const _hoisted_16 = { class: "pip-label" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pip active bonus-pip" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pip-label" }, "Bonus round — 1 pt available", -1))
const _hoisted_19 = {
  key: 3,
  class: "guess-section"
}
const _hoisted_20 = {
  key: 4,
  class: "bonus-round-section"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bonus-prompt" }, "Last chance — pick the correct game for 1 point:", -1))
const _hoisted_22 = { class: "bonus-choices" }
const _hoisted_23 = {
  key: 5,
  class: "wrong-msg"
}
const _hoisted_24 = {
  key: 6,
  class: "franchise-hint"
}
const _hoisted_25 = {
  key: 7,
  class: "wrong-guesses"
}
const _hoisted_26 = {
  key: 8,
  class: "result-section win"
}
const _hoisted_27 = { class: "score-display" }
const _hoisted_28 = { class: "game-reveal" }
const _hoisted_29 = {
  key: 0,
  class: "no-count-note"
}
const _hoisted_30 = {
  key: 1,
  class: "login-nudge"
}
const _hoisted_31 = {
  key: 9,
  class: "result-section loss"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Better luck next time!", -1))
const _hoisted_33 = { class: "game-reveal" }
const _hoisted_34 = {
  key: 0,
  class: "no-count-note"
}
const _hoisted_35 = {
  key: 1,
  class: "game-details"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Category:", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Platform:", -1))
const _hoisted_40 = { key: 2 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Year:", -1))
const _hoisted_42 = { key: 3 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Developer:", -1))
const _hoisted_44 = {
  key: 2,
  class: "wrong-guesses result-guesses"
}
const _hoisted_45 = {
  key: 3,
  class: "login-nudge"
}
const _hoisted_46 = { class: "leaderboard-section" }
const _hoisted_47 = {
  key: 0,
  class: "login-nudge mb-3"
}
const _hoisted_48 = { class: "leaderboard-title" }
const _hoisted_49 = {
  key: 1,
  class: "d-flex justify-center py-3"
}
const _hoisted_50 = {
  key: 2,
  class: "text-grey py-2",
  style: {"font-size":"0.85rem"}
}
const _hoisted_51 = {
  key: 3,
  class: "leaderboard-table"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "Player"),
    /*#__PURE__*/_createElementVNode("th", null, "Score"),
    /*#__PURE__*/_createElementVNode("th", null, "Wins"),
    /*#__PURE__*/_createElementVNode("th", null, "Played")
  ])
], -1))
const _hoisted_53 = { class: "rank-cell" }
const _hoisted_54 = { key: 3 }
const _hoisted_55 = { class: "score-cell" }
const _hoisted_56 = { class: "text-grey" }
const _hoisted_57 = { class: "leaderboard-title-row" }
const _hoisted_58 = { class: "leaderboard-title" }
const _hoisted_59 = { class: "period-toggle" }
const _hoisted_60 = {
  key: 4,
  class: "d-flex justify-center py-3"
}
const _hoisted_61 = {
  key: 5,
  class: "text-grey py-2",
  style: {"font-size":"0.85rem"}
}
const _hoisted_62 = {
  key: 6,
  class: "leaderboard-table"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "Player"),
    /*#__PURE__*/_createElementVNode("th", null, "Score"),
    /*#__PURE__*/_createElementVNode("th", null, "Wins"),
    /*#__PURE__*/_createElementVNode("th", null, "Played")
  ])
], -1))
const _hoisted_64 = { class: "rank-cell" }
const _hoisted_65 = { key: 3 }
const _hoisted_66 = { class: "score-cell" }
const _hoisted_67 = { class: "text-grey" }

import { ref, computed, onMounted, onUnmounted } from 'vue';
import axios from 'axios';
import { userService } from '@/services/user.service';

// --- State ---

export default /*#__PURE__*/_defineComponent({
  __name: 'GuesserView',
  setup(__props) {

const challengeId = ref<string | null>(null);
const screenshots = ref<string[]>([]);
const screenshotIndex = ref(0);
const screenshotLoading = ref(false);
const clues = ref<{ label: string; value: string }[]>([]);
const guessesUsed = ref(0);
const gameOver = ref(false);
const won = ref(false);
const lost = ref(false);
const finalScore = ref(0);
const revealedGameName = ref('');
const revealedGame = ref<any>(null);

const currentGuess = ref('');
const gamesList = ref<string[]>([]);
const loading = ref(false);
const submitting = ref(false);
const unavailable = ref(false);
const wrongMessage = ref('');
const wrongGuesses = ref<string[]>([]);
const franchiseHint = ref('');
const bonusRound = ref(false);
const bonusChoices = ref<string[]>([]);

const dailyRemaining = ref<number | null>(null);
const resetAt = ref<string | null>(null);
const timeUntilReset = ref('');
const lastGameScored = ref<boolean | null>(null);
let countdownTimer: any = null;

const dailyLeaderboard = ref<any[]>([]);
const dailyLeaderboardLoading = ref(false);
const secondaryLeaderboard = ref<any[]>([]);
const secondaryLeaderboardLoading = ref(false);
const secondaryPeriod = ref<'monthly' | 'alltime'>('monthly');

const loggedIn = ref(!!userService.jwt);
const currentUsername = ref(userService.username);

const pointsAvailable = computed(() => Math.max(5 - guessesUsed.value, 2));

function authHeaders() {
    if (!userService.jwt) return {};
    return { Authorization: 'Bearer ' + userService.jwt };
}

// --- Daily status ---
async function loadDailyStatus() {
    try {
        const resp = await axios.get('/api/guesser/daily-status', { headers: authHeaders() });
        applyDailyStatus(resp.data);
    } catch (e) {
        console.error('Failed to load daily status', e);
    }
}

function applyDailyStatus(status: { remaining: number | null; resetAt: string | null }) {
    dailyRemaining.value = status.remaining;
    resetAt.value = status.resetAt;
    const resetTime = status.resetAt ? new Date(status.resetAt).getTime() : null;
    if (status.remaining === 0 && resetTime && resetTime > Date.now()) {
        startCountdown(resetTime);
    } else {
        stopCountdown();
        timeUntilReset.value = '';
    }
}

function startCountdown(endTime: number) {
    stopCountdown();
    let expired = false;
    function tick() {
        const diff = endTime - Date.now();
        if (diff <= 0) {
            stopCountdown();
            timeUntilReset.value = '';
            if (!expired) {
                expired = true;
                loadDailyStatus();
            }
            return;
        }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        timeUntilReset.value = `${h}h ${m}m ${s}s`;
    }
    countdownTimer = setInterval(tick, 1000);
    tick();
}

function stopCountdown() {
    if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
}

function pushScreenshot(data: string) {
    screenshots.value.push(data);
    screenshotIndex.value = screenshots.value.length - 1;
}

// --- Game list for autocomplete ---
async function loadGamesList() {
    try {
        const resp = await axios.get('/api/guesser/games');
        gamesList.value = resp.data;
    } catch (e) {
        console.error('Failed to load games list', e);
    }
}

// --- Start a new challenge ---
async function startChallenge(fresh = false) {
    challengeId.value = null;
    screenshots.value = [];
    screenshotIndex.value = 0;
    clues.value = [];
    guessesUsed.value = 0;
    gameOver.value = false;
    won.value = false;
    lost.value = false;
    finalScore.value = 0;
    revealedGameName.value = '';
    revealedGame.value = null;
    currentGuess.value = '';
    wrongMessage.value = '';
    wrongGuesses.value = [];
    franchiseHint.value = '';
    bonusRound.value = false;
    bonusChoices.value = [];
    unavailable.value = false;
    lastGameScored.value = null;
    loading.value = true;
    loadDailyStatus();

    try {
        const params = fresh ? '?fresh=true' : '';
        const resp = await axios.get(`/api/guesser/challenge${params}`, { headers: authHeaders() });
        challengeId.value = resp.data.challengeId;
        clues.value = resp.data.clues || [];
        if (resp.data.imageData) pushScreenshot(resp.data.imageData);

        if (resp.data.resumed) {
            guessesUsed.value = resp.data.guessesUsed || 0;
            if (resp.data.bonusRound) {
                bonusRound.value = true;
                bonusChoices.value = resp.data.choices || [];
            }
        }
    } catch (e: any) {
        if (e?.response?.status === 503) unavailable.value = true;
        console.error('Challenge error:', e?.response?.data?.error || e);
    } finally {
        loading.value = false;
    }
}

// --- Submit a guess ---
async function submitGuess() {
    if (!currentGuess.value || !challengeId.value || submitting.value) return;

    submitting.value = true;
    wrongMessage.value = '';

    try {
        const resp = await axios.post(
            '/api/guesser/guess',
            { challengeId: challengeId.value, guess: currentGuess.value },
            { headers: authHeaders() }
        );
        const data = resp.data;

        if (data.correct) {
            won.value = true;
            gameOver.value = true;
            finalScore.value = data.score;
            revealedGameName.value = data.gameName;
            revealedGame.value = data.gameData;
            clues.value = data.clues || [];
            lastGameScored.value = data.scored ?? null;
            bonusRound.value = false;
            await Promise.all([loadAllLeaderboards(), loadDailyStatus()]);
        } else if (data.lost) {
            lost.value = true;
            gameOver.value = true;
            revealedGameName.value = data.gameName;
            revealedGame.value = data.gameData;
            clues.value = data.clues || [];
            guessesUsed.value = 4;
            lastGameScored.value = data.scored ?? null;
            bonusRound.value = false;
            await Promise.all([loadAllLeaderboards(), loadDailyStatus()]);
        } else if (data.bonusRound) {
            guessesUsed.value = 4;
            clues.value = data.clues || [];
            wrongGuesses.value.push(currentGuess.value);
            franchiseHint.value = data.franchiseHint || '';
            currentGuess.value = '';
            bonusRound.value = true;
            bonusChoices.value = data.choices || [];
        } else {
            guessesUsed.value = data.guessesUsed;
            clues.value = data.clues || [];
            wrongGuesses.value.push(currentGuess.value);
            wrongMessage.value = `"${currentGuess.value}" is not the answer. Try again!`;
            franchiseHint.value = data.franchiseHint || '';
            currentGuess.value = '';
            if (data.imageData) pushScreenshot(data.imageData);
        }
    } catch (e: any) {
        wrongMessage.value = e?.response?.data?.error || 'An error occurred, please try again.';
    } finally {
        submitting.value = false;
    }
}

async function submitBonusGuess(choice: string) {
    currentGuess.value = choice;
    await submitGuess();
}

// --- Leaderboard ---
async function loadDailyLeaderboard() {
    dailyLeaderboardLoading.value = true;
    try {
        const resp = await axios.get('/api/guesser/leaderboard?period=daily');
        dailyLeaderboard.value = resp.data;
    } catch (e) {
        console.error('Failed to load daily leaderboard', e);
    } finally {
        dailyLeaderboardLoading.value = false;
    }
}

async function loadSecondaryLeaderboard() {
    secondaryLeaderboardLoading.value = true;
    try {
        const resp = await axios.get(`/api/guesser/leaderboard?period=${secondaryPeriod.value}`);
        secondaryLeaderboard.value = resp.data;
    } catch (e) {
        console.error('Failed to load leaderboard', e);
    } finally {
        secondaryLeaderboardLoading.value = false;
    }
}

async function loadAllLeaderboards() {
    await Promise.all([loadDailyLeaderboard(), loadSecondaryLeaderboard()]);
}

async function switchSecondaryPeriod(period: 'monthly' | 'alltime') {
    secondaryPeriod.value = period;
    await loadSecondaryLeaderboard();
}

function claimChallenge() {
    if (!loggedIn.value || !challengeId.value || gameOver.value) return;
    axios.post('/api/guesser/claim', { challengeId: challengeId.value }, { headers: authHeaders() })
        .catch(e => console.warn('claim failed:', e?.response?.data?.error || e));
}

async function tryResume(): Promise<boolean> {
    try {
        const resp = await axios.get('/api/guesser/resume', { headers: authHeaders() });
        if (resp.data.none) return false;
        const data = resp.data;
        challengeId.value = data.challengeId;
        guessesUsed.value = data.guessesUsed;
        clues.value = data.clues || [];
        if (data.imageData) pushScreenshot(data.imageData);
        if (data.bonusRound) {
            bonusRound.value = true;
            bonusChoices.value = data.choices || [];
        }
        return true;
    } catch (e) {
        return false;
    }
}

onMounted(async () => {
    loadGamesList();
    loadAllLeaderboards();

    // Wait for auth to fully resolve before subscribing; this ensures the
    // ReplaySubject replays the real user (not the initial null) synchronously,
    // so loggedIn is correct before we decide to resume or start.
    try { await userService.ready; } catch (_) { /* ignore */ }

    userService.getCurrentUser().subscribe((user: any) => {
        const wasLoggedIn = loggedIn.value;
        loggedIn.value = !!user;
        currentUsername.value = user?.username || '';
        if (user || !wasLoggedIn) loadDailyStatus();
        if (user && !wasLoggedIn) claimChallenge();
    });

    startChallenge();
});

onUnmounted(() => {
    stopCountdown();
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_card, {
        class: "guesser-card",
        elevation: "8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "card-header" }, {
            default: _withCtx(() => [
              _hoisted_3,
              (loggedIn.value && dailyRemaining.value !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (dailyRemaining.value > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(dailyRemaining.value) + " leaderboard challenge" + _toDisplayString(dailyRemaining.value !== 1 ? 's' : '') + " remaining today ", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Leaderboard challenges refresh in " + _toDisplayString(timeUntilReset.value), 1)
                        ], 64))
                  ]))
                : _createCommentVNode("", true),
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "card-body" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "7",
                    lg: "8",
                    class: "game-col"
                  }, {
                    default: _withCtx(() => [
                      (unavailable.value && !loading.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                            _createVNode(_component_v_icon, { color: "warning" }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-alert")
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Challenge temporarily unavailable — stream bot is not connected. ")
                          ]))
                        : _createCommentVNode("", true),
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              color: "primary",
                              size: "64"
                            }),
                            _hoisted_8
                          ]))
                        : _createCommentVNode("", true),
                      (challengeId.value && !loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              (screenshots.value.length)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: screenshots.value[screenshotIndex.value],
                                    class: "game-screenshot",
                                    alt: "Game screenshot"
                                  }, null, 8, _hoisted_11))
                                : _createCommentVNode("", true),
                              (screenshotLoading.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 1,
                                    indeterminate: "",
                                    color: "primary",
                                    class: "screenshot-spinner"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (screenshots.value.length > 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_v_btn, {
                                    icon: "",
                                    size: "small",
                                    variant: "text",
                                    disabled: screenshotIndex.value === 0,
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (screenshotIndex.value--))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-chevron-left")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]),
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(screenshotIndex.value + 1) + " / " + _toDisplayString(screenshots.value.length), 1),
                                  _createVNode(_component_v_btn, {
                                    icon: "",
                                    size: "small",
                                    variant: "text",
                                    disabled: screenshotIndex.value === screenshots.value.length - 1,
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (screenshotIndex.value++))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-chevron-right")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true),
                            (clues.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clues.value, (clue) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: clue.label,
                                      class: "clue-chip"
                                    }, [
                                      _createElementVNode("strong", null, _toDisplayString(clue.label) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(clue.value), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (!gameOver.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  (!bonusRound.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                                          return _createElementVNode("span", {
                                            key: i,
                                            class: _normalizeClass(["pip", { active: i <= pointsAvailable.value }])
                                          }, null, 2)
                                        }), 64)),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(pointsAvailable.value) + " pt" + _toDisplayString(pointsAvailable.value !== 1 ? 's' : '') + " available", 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_17,
                                        _hoisted_18
                                      ], 64))
                                ]))
                              : _createCommentVNode("", true),
                            (!gameOver.value && !bonusRound.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_component_v_autocomplete, {
                                    modelValue: currentGuess.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentGuess).value = $event)),
                                    items: gamesList.value,
                                    label: "Search for a game...",
                                    variant: "outlined",
                                    clearable: "",
                                    "hide-no-data": "",
                                    "auto-select-first": "",
                                    class: "guess-input",
                                    onKeydown: _withKeys(submitGuess, ["enter"]),
                                    disabled: submitting.value,
                                    density: "comfortable"
                                  }, null, 8, ["modelValue", "items", "onKeydown", "disabled"]),
                                  _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    onClick: submitGuess,
                                    disabled: !currentGuess.value || submitting.value,
                                    loading: submitting.value,
                                    class: "guess-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Guess ")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "loading"])
                                ]))
                              : _createCommentVNode("", true),
                            (bonusRound.value && !gameOver.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _hoisted_21,
                                  _createElementVNode("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bonusChoices.value, (choice) => {
                                      return (_openBlock(), _createBlock(_component_v_btn, {
                                        key: choice,
                                        variant: "outlined",
                                        class: "bonus-choice-btn",
                                        disabled: submitting.value,
                                        loading: submitting.value && currentGuess.value === choice,
                                        onClick: ($event: any) => (submitBonusGuess(choice))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(choice), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled", "loading", "onClick"]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (wrongMessage.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                                  _createVNode(_component_v_icon, {
                                    color: "error",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-close-circle")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(wrongMessage.value), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (franchiseHint.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                  _createVNode(_component_v_icon, {
                                    color: "amber",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-star")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" You're in the right franchise: "),
                                  _createElementVNode("strong", null, _toDisplayString(franchiseHint.value), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (wrongGuesses.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wrongGuesses.value, (g) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: g,
                                      class: "wrong-guess-chip"
                                    }, [
                                      _createVNode(_component_v_icon, {
                                        size: "12",
                                        color: "error"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-close")
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(g), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (won.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createVNode(_component_v_icon, {
                                    color: "success",
                                    size: "48"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-trophy")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("h2", null, [
                                    _createTextVNode("Correct! "),
                                    _createElementVNode("span", _hoisted_27, "+" + _toDisplayString(finalScore.value) + " point" + _toDisplayString(finalScore.value !== 1 ? 's' : ''), 1)
                                  ]),
                                  _createElementVNode("p", _hoisted_28, [
                                    _createTextVNode("The game was: "),
                                    _createElementVNode("strong", null, _toDisplayString(revealedGameName.value), 1)
                                  ]),
                                  (lastGameScored.value === false)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, "This game did not count toward the leaderboard (daily limit reached)."))
                                    : _createCommentVNode("", true),
                                  (!loggedIn.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createVNode(_component_router_link, { to: "/login" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Log in")
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" to save your score to the leaderboard. ")
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_btn, {
                                    class: "mt-4",
                                    color: "primary",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (startChallenge(true)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Play Again")
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (lost.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createVNode(_component_v_icon, {
                                    color: "error",
                                    size: "48"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-emoticon-sad")
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_32,
                                  _createElementVNode("p", _hoisted_33, [
                                    _createTextVNode("The game was: "),
                                    _createElementVNode("strong", null, _toDisplayString(revealedGameName.value), 1)
                                  ]),
                                  (lastGameScored.value === false)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, "This game did not count toward the leaderboard (daily limit reached)."))
                                    : _createCommentVNode("", true),
                                  (revealedGame.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        (revealedGame.value.category)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                              _hoisted_37,
                                              _createTextVNode(" " + _toDisplayString(revealedGame.value.category), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (revealedGame.value.platform)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                              _hoisted_39,
                                              _createTextVNode(" " + _toDisplayString(revealedGame.value.platform), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (revealedGame.value.year)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                              _hoisted_41,
                                              _createTextVNode(" " + _toDisplayString(revealedGame.value.year), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (revealedGame.value.developer)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                              _hoisted_43,
                                              _createTextVNode(" " + _toDisplayString(revealedGame.value.developer), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (wrongGuesses.value.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wrongGuesses.value, (g) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: g,
                                            class: "wrong-guess-chip"
                                          }, [
                                            _createVNode(_component_v_icon, {
                                              size: "12",
                                              color: "error"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-close")
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode(" " + _toDisplayString(g), 1)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!loggedIn.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                        _createVNode(_component_router_link, { to: "/login" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Log in")
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" to appear on the leaderboard. ")
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_btn, {
                                    class: "mt-4",
                                    color: "primary",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (startChallenge(true)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Try Again")
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "5",
                    lg: "4",
                    class: "leaderboard-col"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_46, [
                        (!loggedIn.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _createVNode(_component_router_link, { to: "/login" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Log in")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" to be counted on the leaderboard. ")
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("h3", _hoisted_48, [
                          _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-calendar-today")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Today ")
                        ]),
                        (dailyLeaderboardLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createVNode(_component_v_progress_circular, {
                                indeterminate: "",
                                color: "primary",
                                size: "24"
                              })
                            ]))
                          : (dailyLeaderboard.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, " No scores today yet — be the first! "))
                            : (_openBlock(), _createElementBlock("table", _hoisted_51, [
                                _hoisted_52,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dailyLeaderboard.value, (entry, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: entry.twitch_id,
                                      class: _normalizeClass({ 'my-row': entry.twitch_id === currentUsername.value })
                                    }, [
                                      _createElementVNode("td", _hoisted_53, [
                                        (index === 0)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              color: "amber-darken-2",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-trophy")
                                              ]),
                                              _: 1
                                            }))
                                          : (index === 1)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 1,
                                                color: "blue-grey-lighten-2",
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-trophy")
                                                ]),
                                                _: 1
                                              }))
                                            : (index === 2)
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 2,
                                                  color: "brown-lighten-2",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("mdi-trophy")
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(index + 1), 1))
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(entry.display_name || entry.twitch_id), 1),
                                      _createElementVNode("td", _hoisted_55, _toDisplayString(entry.total_score), 1),
                                      _createElementVNode("td", null, _toDisplayString(entry.wins), 1),
                                      _createElementVNode("td", _hoisted_56, _toDisplayString(entry.games_played), 1)
                                    ], 2))
                                  }), 128))
                                ])
                              ])),
                        _createVNode(_component_v_divider, { class: "my-4" }),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("h3", _hoisted_58, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-podium")
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(secondaryPeriod.value === 'monthly' ? 'This Month' : 'All Time'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["period-btn", { active: secondaryPeriod.value === 'monthly' }]),
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (switchSecondaryPeriod('monthly')))
                            }, "Monthly", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(["period-btn", { active: secondaryPeriod.value === 'alltime' }]),
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (switchSecondaryPeriod('alltime')))
                            }, "All Time", 2)
                          ])
                        ]),
                        (secondaryLeaderboardLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _createVNode(_component_v_progress_circular, {
                                indeterminate: "",
                                color: "primary",
                                size: "24"
                              })
                            ]))
                          : (secondaryLeaderboard.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, " No scores yet — be the first! "))
                            : (_openBlock(), _createElementBlock("table", _hoisted_62, [
                                _hoisted_63,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondaryLeaderboard.value, (entry, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: entry.twitch_id,
                                      class: _normalizeClass({ 'my-row': entry.twitch_id === currentUsername.value })
                                    }, [
                                      _createElementVNode("td", _hoisted_64, [
                                        (index === 0)
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              color: "amber-darken-2",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-trophy")
                                              ]),
                                              _: 1
                                            }))
                                          : (index === 1)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 1,
                                                color: "blue-grey-lighten-2",
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-trophy")
                                                ]),
                                                _: 1
                                              }))
                                            : (index === 2)
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 2,
                                                  color: "brown-lighten-2",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("mdi-trophy")
                                                  ]),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(index + 1), 1))
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(entry.display_name || entry.twitch_id), 1),
                                      _createElementVNode("td", _hoisted_66, _toDisplayString(entry.total_score), 1),
                                      _createElementVNode("td", null, _toDisplayString(entry.wins), 1),
                                      _createElementVNode("td", _hoisted_67, _toDisplayString(entry.games_played), 1)
                                    ], 2))
                                  }), 128))
                                ])
                              ]))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})